import { c as _c } from "react/compiler-runtime";
import { CircleQuestionMarkIcon } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
type NodeInfoDialogProps = {
  label: string;
  description: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * Reusable dialog component for displaying node information.
 * Used by TraitNode and ArticulationPointNode.
 */
export function NodeInfoDialog(t0) {
  const $ = _c(17);
  const {
    label,
    description,
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CircleQuestionMarkIcon className="text-muted-foreground" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <DialogTitle>{label}</DialogTitle>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <DialogDescription className="sr-only">{description}</DialogDescription>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <DialogHeader className="-mx-4 flex flex-row items-center gap-2 border-b px-4 pb-2 capitalize">{t1}{t2}{t3}</DialogHeader>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== description) {
    t5 = <p>{description}</p>;
    $[8] = description;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <DialogContent>{t4}{t5}</DialogContent>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onOpenChange || $[14] !== open || $[15] !== t6) {
    t7 = <Dialog open={open} onOpenChange={onOpenChange}>{t6}</Dialog>;
    $[13] = onOpenChange;
    $[14] = open;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}